// removed by extract-text-webpack-plugin
module.exports = {"edit-funds-button":"edit-funds-button__32AQJ","header-text":"header-text__17jj1","edit-funds-link":"edit-funds-link__3Ir4K","table-header":"table-header__2_fRx"};


//////////////////
// WEBPACK FOOTER
// ./styles/homePage/plan.scss
// module id = 236
// module chunks = 68